package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.Bsoft: ImageVector
    get() {
        if (_bsoft != null) {
            return _bsoft!!
        }
        _bsoft = Builder(name = "Bsoft", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp,
                viewportWidth = 512.0f, viewportHeight = 512.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = SolidColor(Color(0x00000000)),
                    strokeLineWidth = 0.761987f, strokeLineCap = Butt, strokeLineJoin = Miter,
                    strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(31.438f, 5.777f)
                curveToRelative(0.0f, 0.152f, -0.229f, 64.693f, -0.381f, 143.482f)
                curveToRelative(-0.457f, 145.54f, -0.229f, 158.951f, 2.362f, 176.857f)
                curveToRelative(9.22f, 62.94f, 44.957f, 118.337f, 99.896f, 155.141f)
                curveToRelative(18.059f, 12.039f, 44.424f, 23.698f, 66.979f, 29.489f)
                curveToRelative(32.384f, 8.458f, 69.95f, 9.144f, 104.24f, 1.905f)
                curveToRelative(64.845f, -13.64f, 123.823f, -59.968f, 153.312f, -120.318f)
                curveToRelative(29.26f, -60.045f, 31.013f, -127.252f, 4.877f, -188.439f)
                curveToRelative(-15.164f, -35.509f, -40.385f, -67.512f, -71.931f, -91.21f)
                curveToRelative(-30.556f, -23.012f, -64.388f, -36.728f, -105.154f, -42.824f)
                curveToRelative(-11.354f, -1.676f, -43.814f, -1.905f, -56.006f, -0.381f)
                curveToRelative(-58.978f, 7.315f, -109.116f, 34.823f, -148.74f, 81.609f)
                lineToRelative(-2.819f, 3.276f)
                lineToRelative(-0.305f, -55.473f)
                curveToRelative(-0.229f, -50.367f, -0.381f, -56.006f, -1.6f, -60.121f)
                curveToRelative(-3.2f, -10.973f, -11.201f, -21.793f, -19.888f, -26.974f)
                curveToRelative(-5.334f, -3.276f, -15.164f, -6.172f, -20.65f, -6.172f)
                curveToRelative(-2.286f, -0.0f, -4.115f, 0.076f, -4.191f, 0.152f)
                close()
                moveTo(277.255f, 115.427f)
                curveToRelative(30.022f, 3.2f, 63.321f, 16.764f, 88.162f, 35.89f)
                curveToRelative(27.66f, 21.412f, 48.996f, 51.815f, 60.349f, 86.333f)
                curveToRelative(8.534f, 26.06f, 10.82f, 58.063f, 6.096f, 86.104f)
                curveToRelative(-5.791f, 34.594f, -23.469f, 68.807f, -48.539f, 94.334f)
                curveToRelative(-48.843f, 49.605f, -122.146f, 66.521f, -186.839f, 43.052f)
                curveToRelative(-57.073f, -20.65f, -99.515f, -67.893f, -113.993f, -126.718f)
                curveToRelative(-8.382f, -34.137f, -6.401f, -69.112f, 5.943f, -103.249f)
                curveToRelative(6.401f, -17.754f, 13.335f, -30.403f, 25.908f, -47.167f)
                curveToRelative(30.022f, -40.004f, 78.104f, -65.836f, 129.309f, -69.417f)
                curveToRelative(9.296f, -0.686f, 23.012f, -0.305f, 33.604f, 0.838f)
                close()
            }
            path(fill = SolidColor(Color(0xFF000000)), stroke = SolidColor(Color(0x00000000)),
                    strokeLineWidth = 0.761987f, strokeLineCap = Butt, strokeLineJoin = Miter,
                    strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(253.329f, 139.201f)
                curveToRelative(-1.829f, 6.782f, -5.867f, 21.259f, -8.991f, 32.156f)
                curveToRelative(-3.124f, 10.896f, -6.858f, 24.765f, -8.306f, 30.861f)
                curveToRelative(-1.448f, 6.096f, -3.124f, 12.954f, -3.734f, 15.24f)
                curveToRelative(-0.61f, 2.286f, -1.143f, 4.572f, -1.143f, 5.029f)
                curveToRelative(0.0f, 0.457f, 2.743f, 0.076f, 7.086f, -1.067f)
                curveToRelative(9.22f, -2.438f, 24.993f, -2.743f, 34.747f, -0.686f)
                curveToRelative(25.374f, 5.486f, 46.634f, 23.088f, 56.539f, 46.938f)
                curveToRelative(4.115f, 9.83f, 5.486f, 18.44f, 5.029f, 31.699f)
                curveToRelative(-0.533f, 16.535f, -4.039f, 27.813f, -12.497f, 40.614f)
                curveToRelative(-9.982f, 14.935f, -27.051f, 27.127f, -44.881f, 31.927f)
                curveToRelative(-6.629f, 1.753f, -9.068f, 1.981f, -20.116f, 2.057f)
                curveToRelative(-10.668f, 0.076f, -13.563f, -0.152f, -19.354f, -1.676f)
                curveToRelative(-12.954f, -3.277f, -24.384f, -9.753f, -34.975f, -19.888f)
                curveToRelative(-7.086f, -6.782f, -11.43f, -12.649f, -15.621f, -21.031f)
                curveToRelative(-4.953f, -9.982f, -7.01f, -17.449f, -8.915f, -33.375f)
                curveToRelative(-0.457f, -3.353f, -1.219f, -4.42f, -8.991f, -12.954f)
                curveToRelative(-9.372f, -10.287f, -16.078f, -16.764f, -17.068f, -16.383f)
                curveToRelative(-0.305f, 0.076f, -1.143f, 1.752f, -1.753f, 3.658f)
                curveToRelative(-1.372f, 3.962f, 2.21f, 2.667f, -36.956f, 13.792f)
                curveToRelative(-13.411f, 3.81f, -24.917f, 7.086f, -25.527f, 7.315f)
                curveToRelative(-0.61f, 0.152f, 12.725f, 4.801f, 29.717f, 10.287f)
                curveToRelative(16.992f, 5.41f, 30.937f, 9.982f, 31.089f, 10.058f)
                curveToRelative(0.076f, 0.152f, 1.067f, 3.962f, 2.21f, 8.458f)
                lineToRelative(2.057f, 8.229f)
                lineToRelative(-6.401f, 6.02f)
                curveToRelative(-3.581f, 3.276f, -8.61f, 7.696f, -11.201f, 9.906f)
                curveToRelative(-2.591f, 2.21f, -4.953f, 4.724f, -5.181f, 5.639f)
                curveToRelative(-0.381f, 1.143f, 1.219f, 4.648f, 5.105f, 11.811f)
                curveToRelative(4.953f, 8.991f, 5.791f, 10.211f, 7.467f, 10.135f)
                curveToRelative(1.067f, -0.076f, 8.077f, -1.905f, 15.697f, -4.115f)
                lineToRelative(13.716f, -4.038f)
                lineToRelative(6.324f, 6.248f)
                curveToRelative(3.429f, 3.429f, 6.172f, 6.629f, 5.944f, 7.163f)
                curveToRelative(-3.353f, 8.991f, -9.068f, 28.041f, -8.687f, 28.955f)
                curveToRelative(0.61f, 1.6f, 19.431f, 12.725f, 21.564f, 12.725f)
                curveToRelative(1.219f, -0.0f, 4.42f, -2.972f, 11.43f, -10.668f)
                curveToRelative(5.563f, -6.02f, 10.363f, -10.668f, 11.125f, -10.668f)
                curveToRelative(2.21f, -0.0f, 14.63f, 3.81f, 15.621f, 4.801f)
                curveToRelative(0.533f, 0.533f, 2.362f, 6.934f, 4.115f, 14.249f)
                curveToRelative(1.676f, 7.315f, 3.429f, 13.792f, 3.886f, 14.249f)
                curveToRelative(0.61f, 0.762f, 4.115f, 0.991f, 12.878f, 0.991f)
                curveToRelative(11.735f, -0.0f, 12.116f, -0.076f, 13.182f, -1.753f)
                curveToRelative(0.533f, -0.914f, 2.286f, -7.163f, 3.886f, -13.868f)
                curveToRelative(1.6f, -6.706f, 3.124f, -12.725f, 3.429f, -13.335f)
                curveToRelative(0.61f, -1.067f, 13.64f, -5.334f, 16.307f, -5.334f)
                curveToRelative(0.61f, -0.0f, 5.258f, 4.572f, 10.363f, 10.058f)
                curveToRelative(5.181f, 5.563f, 10.058f, 10.516f, 10.973f, 11.049f)
                curveToRelative(1.829f, 0.991f, 1.448f, 1.219f, 13.64f, -6.02f)
                curveToRelative(8.001f, -4.877f, 8.915f, -5.562f, 8.915f, -7.544f)
                curveToRelative(0.0f, -1.143f, -1.676f, -7.62f, -3.81f, -14.325f)
                curveToRelative(-2.057f, -6.705f, -3.81f, -12.801f, -3.81f, -13.563f)
                curveToRelative(0.0f, -0.762f, 2.667f, -4.039f, 5.943f, -7.315f)
                lineToRelative(5.943f, -5.867f)
                lineToRelative(14.249f, 4.191f)
                curveToRelative(7.848f, 2.286f, 14.706f, 4.191f, 15.316f, 4.191f)
                curveToRelative(0.991f, -0.0f, 12.649f, -20.116f, 12.649f, -21.869f)
                curveToRelative(0.0f, -0.381f, -5.105f, -5.486f, -11.43f, -11.201f)
                curveToRelative(-6.248f, -5.791f, -11.43f, -10.515f, -11.43f, -10.592f)
                curveToRelative(0.076f, -0.076f, 0.991f, -3.734f, 2.134f, -8.077f)
                lineToRelative(2.057f, -7.925f)
                lineToRelative(11.43f, -2.972f)
                curveToRelative(6.324f, -1.6f, 13.259f, -3.429f, 15.545f, -4.115f)
                lineToRelative(4.039f, -1.143f)
                lineToRelative(-0.305f, -12.192f)
                curveToRelative(-0.229f, -8.763f, -0.533f, -12.344f, -1.219f, -12.801f)
                curveToRelative(-0.533f, -0.305f, -7.391f, -2.057f, -15.24f, -3.886f)
                curveToRelative(-7.848f, -1.753f, -14.478f, -3.429f, -14.783f, -3.734f)
                curveToRelative(-0.305f, -0.305f, -1.676f, -4.191f, -2.972f, -8.687f)
                lineToRelative(-2.438f, -8.153f)
                lineToRelative(3.505f, -3.962f)
                curveToRelative(1.905f, -2.21f, 11.811f, -12.801f, 22.098f, -23.469f)
                curveToRelative(10.211f, -10.668f, 18.364f, -19.507f, 18.135f, -19.583f)
                curveToRelative(-0.229f, -0.152f, -6.782f, 1.524f, -14.554f, 3.581f)
                curveToRelative(-7.772f, 2.134f, -21.64f, 5.791f, -30.937f, 8.153f)
                lineToRelative(-16.764f, 4.267f)
                lineToRelative(-7.315f, -7.315f)
                lineToRelative(-7.315f, -7.315f)
                lineToRelative(6.705f, -28.803f)
                curveToRelative(3.658f, -15.849f, 6.934f, -29.87f, 7.239f, -31.089f)
                lineToRelative(0.61f, -2.286f)
                lineToRelative(-3.353f, 3.048f)
                curveToRelative(-1.753f, 1.676f, -12.344f, 11.887f, -23.469f, 22.707f)
                curveToRelative(-17.678f, 17.297f, -20.345f, 19.659f, -22.098f, 19.354f)
                curveToRelative(-1.067f, -0.229f, -5.258f, -1.219f, -9.22f, -2.286f)
                lineToRelative(-7.163f, -1.905f)
                lineToRelative(-1.753f, -5.181f)
                curveToRelative(-2.21f, -6.477f, -7.544f, -24.993f, -12.497f, -43.662f)
                curveToRelative(-1.981f, -7.696f, -3.81f, -14.097f, -3.962f, -14.249f)
                curveToRelative(-0.076f, -0.152f, -1.676f, 5.334f, -3.505f, 12.116f)
                close()
            }
            path(fill = SolidColor(Color(0xFF000000)), stroke = SolidColor(Color(0x00000000)),
                    strokeLineWidth = 0.761987f, strokeLineCap = Butt, strokeLineJoin = Miter,
                    strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(173.549f, 150.021f)
                curveToRelative(0.762f, 2.819f, 8.687f, 35.661f, 11.43f, 47.624f)
                curveToRelative(2.438f, 10.973f, 5.105f, 33.68f, 4.039f, 34.823f)
                curveToRelative(-0.914f, 0.838f, -3.734f, -0.838f, -7.01f, -4.038f)
                curveToRelative(-3.353f, -3.277f, -6.096f, -4.191f, -7.696f, -2.591f)
                curveToRelative(-0.838f, 0.838f, -22.098f, -4.496f, -48.081f, -12.039f)
                curveToRelative(-8.534f, -2.438f, -15.468f, -4.191f, -15.468f, -3.886f)
                curveToRelative(0.0f, 0.914f, 42.9f, 44.805f, 48.31f, 49.453f)
                curveToRelative(2.743f, 2.286f, 8.229f, 8.534f, 12.268f, 13.868f)
                curveToRelative(7.01f, 9.296f, 8.763f, 11.049f, 8.763f, 8.687f)
                curveToRelative(0.0f, -2.21f, 4.039f, -13.335f, 7.239f, -20.04f)
                curveToRelative(5.105f, -10.439f, 13.64f, -20.498f, 25.527f, -29.946f)
                curveToRelative(2.743f, -2.134f, 5.486f, -4.801f, 6.248f, -5.944f)
                curveToRelative(1.6f, -2.515f, 5.943f, -19.964f, 5.943f, -23.774f)
                curveToRelative(0.0f, -3.048f, 2.819f, -0.076f, -38.328f, -40.385f)
                curveToRelative(-7.544f, -7.315f, -13.487f, -12.649f, -13.182f, -11.811f)
                close()
            }
        }
        .build()
        return _bsoft!!
    }

private var _bsoft: ImageVector? = null
